import React from 'react';
import { signOut } from "firebase/auth";
import { auth, db } from '../../firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDollarSign, faClock, faBell, faSearch, faDownload, faUserPlus, faChartBar, faSignOutAlt, 
    faFolder, faBook, faMobileAlt } from '@fortawesome/free-solid-svg-icons';
import { collection,  getDocs,  } from 'firebase/firestore';
import '../styles/HomePage.css'; 
import logo from '../../assets/logo.png'; 
import * as XLSX from 'xlsx'; 
import backgroundImage from '../../assets/background5.jpg';





function HomePage() {
    const navigate = useNavigate();


const handleDownload = async () => {
    try {
        console.log('Iniciando generación de backup...');
        
        // Referencias a las colecciones
        const cuentasRef = collection(db, 'Cuentas');
        const ventasOnlineRef = collection(db, 'ventasOnline');
        const ventasRef = collection(db, 'Ventas');
        const receiptsRef = collection(db, 'receipts');

        // Obtener datos de todas las colecciones en paralelo
        const [cuentasSnapshot, ventasOnlineSnapshot, ventasSnapshot, receiptsSnapshot] = await Promise.all([
            getDocs(cuentasRef),
            getDocs(ventasOnlineRef),
            getDocs(ventasRef),
            getDocs(receiptsRef)
        ]);

        // Convertir snapshots a arrays de objetos
        const cuentasData = cuentasSnapshot.docs.map((doc) => ({ 
            id: doc.id, 
            ...doc.data() 
        }));
        
        const ventasOnlineData = ventasOnlineSnapshot.docs.map((doc) => ({ 
            id: doc.id, 
            ...doc.data() 
        }));
        
        const ventasData = ventasSnapshot.docs.map((doc) => ({ 
            id: doc.id, 
            ...doc.data() 
        }));

        const receiptsData = receiptsSnapshot.docs.map((doc) => ({ 
            id: doc.id, 
            ...doc.data() 
        }));

        // Verificar si hay datos para exportar
        const totalRecords = cuentasData.length + ventasOnlineData.length + ventasData.length + receiptsData.length;
        if (totalRecords === 0) {
            alert('No hay datos disponibles para exportar.');
            return;
        }

        // Crear un nuevo libro de trabajo (workbook)
        const workbook = XLSX.utils.book_new();

        // Crear hojas de trabajo (worksheets) solo si hay datos
        if (cuentasData.length > 0) {
            const cuentasWorksheet = XLSX.utils.json_to_sheet(cuentasData);
            XLSX.utils.book_append_sheet(workbook, cuentasWorksheet, 'Cuentas');
            console.log(`Hoja "Cuentas" creada con ${cuentasData.length} registros`);
        }

        if (ventasOnlineData.length > 0) {
            const ventasOnlineWorksheet = XLSX.utils.json_to_sheet(ventasOnlineData);
            XLSX.utils.book_append_sheet(workbook, ventasOnlineWorksheet, 'Online');
            console.log(`Hoja "Online" creada con ${ventasOnlineData.length} registros`);
        }

        if (ventasData.length > 0) {
            const ventasWorksheet = XLSX.utils.json_to_sheet(ventasData);
            XLSX.utils.book_append_sheet(workbook, ventasWorksheet, 'Clasico');
            console.log(`Hoja "Clasico" creada con ${ventasData.length} registros`);
        }

        if (receiptsData.length > 0) {
            const receiptsWorksheet = XLSX.utils.json_to_sheet(receiptsData);
            XLSX.utils.book_append_sheet(workbook, receiptsWorksheet, 'Recibos');
            console.log(`Hoja "Recibos" creada con ${receiptsData.length} registros`);
        }

        // Generar nombre de archivo con fecha y hora
        const now = new Date();
        const timestamp = now.toISOString().slice(0, 19).replace(/:/g, '-');
        const fileName = `backup_completo_${timestamp}.xlsx`;

        // Descargar el archivo
        XLSX.writeFile(workbook, fileName);
        
        // Mensaje de éxito con detalles
        const message = `✅ Backup generado exitosamente!\n\n` +
                       `📊 Resumen:\n` +
                       `• Cuentas: ${cuentasData.length} registros\n` +
                       `• Ventas Online: ${ventasOnlineData.length} registros\n` +
                       `• Ventas Clásico: ${ventasData.length} registros\n` +
                       `• Recibos: ${receiptsData.length} registros\n` +
                       `• Total: ${totalRecords} registros\n\n` +
                       `📁 Archivo: ${fileName}`;
        
        alert(message);
        
    } catch (error) {
        console.error('Error detallado al generar el backup:', error);
        
        // Manejo de errores más específico
        let errorMessage = 'Ocurrió un error al generar el backup.';
        
        if (error.code === 'permission-denied') {
            errorMessage = 'Error: No tienes permisos para acceder a los datos.';
        } else if (error.code === 'unavailable') {
            errorMessage = 'Error: Servicio no disponible. Intenta más tarde.';
        } else if (error.message.includes('network')) {
            errorMessage = 'Error de conexión. Verifica tu internet.';
        }
        
        alert(`❌ ${errorMessage}\n\nDetalles técnicos: ${error.message}`);
    }
};
    

    const handleSignOut = async () => {
        try {
            await signOut(auth);
            alert('Has cerrado sesión exitosamente.');
            navigate('/');
        } catch (error) {
            alert('Error al cerrar sesión: ' + error.message);
        }
    };

    const navigateToSales = () => {
        navigate('/register-sales');
    };

    const goToStatistics = () => {
        navigate('/statistics');
    };

    const goToAccountRegistration = () => {
        navigate('/register-account');
    };

    const goToRegisterSeller = () => {
        navigate('/register-seller');
    };

    const goToCatalog = () => {
        navigate('/catalog');
    };

        const goToSubscriptionSearch = () => {
        navigate('/subscription-search');
    };


    const backgroundStyle = {
        minHeight: '100vh',
        width: '100%',
        margin: 0,
        padding: 0,
        backgroundImage: `linear-gradient(
            rgba(0, 0, 0, 0.51), 
            rgba(0, 0, 0, 0.51)
        ), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
        overflowX: 'hidden' 
    };

    return (
        <div style={backgroundStyle}>
        <div className="container-xyzz">
            <div className="content-xyzz">
            <img src={logo} alt="Logo" className="logo-xyzz" />
                <p className="subHeader-xyzz">Has iniciado sesión exitosamente en nuestra plataforma.</p>

                <div className="button-grid-xyzz">
                    <button className="button-xyzz" onClick={navigateToSales}>
                        <FontAwesomeIcon icon={faDollarSign} /> Registrar Ventas
                    </button>
                    <button className="button-xyzz" onClick={() => navigate('/platform-accounts')}>
                        <FontAwesomeIcon icon={faClock} /> Cuentas a Vencer
                    </button>
                    <button className="button-xyzz" onClick={() => navigate('/expiring-subscriptions')}>
                        <FontAwesomeIcon icon={faBell} /> Suscripciones por Vencer
                    </button>
                    <button className="button-xyzz" onClick={() => navigate('/account-search')}>
                        <FontAwesomeIcon icon={faSearch} /> Modificar Suscripciones
                    </button>
                    <button className="button-xyzz" onClick={goToCatalog}>
                        <FontAwesomeIcon icon={faBook} /> Catálogo
                    </button>
                    <button className="button-xyzz" onClick={handleDownload}>
                        <FontAwesomeIcon icon={faDownload} /> Backup
                    </button>
                    <button className="button-xyzz" onClick={goToAccountRegistration}>
                        <FontAwesomeIcon icon={faFolder} /> Registrar Cuentas
                    </button>
                    <button className="button-xyzz" onClick={goToRegisterSeller}>
                        <FontAwesomeIcon icon={faUserPlus} /> Registrar Vendedores
                    </button>

                    <button className="button-xyzz" onClick={goToSubscriptionSearch}>
                        <FontAwesomeIcon icon={faMobileAlt} /> Busqueda por Número o Email
                    </button>
                </div>

                <div className="footer-buttons-xyzz">
                    <button className="button-xyzz" onClick={goToStatistics}>
                        <FontAwesomeIcon icon={faChartBar} /> Estadísticas
                    </button>
                    <button className="button-xyzz button-signout-xyzz" onClick={handleSignOut}>
                        <FontAwesomeIcon icon={faSignOutAlt} /> Cerrar Sesión
                    </button>
                </div>
            </div>
        </div>
    </div>
    );
}

export default HomePage;
